import { paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'

/**
 * Returns entity type list for live search.
 * @param countryCode
 * @param storeName
 * @param keyword
 * @param device
 * @returns {Promise<any>}
 */
export function getLiveSearchEntityList({ storeName, countryCode, keyword, device }) {
  return makeRequest(`/keyword/live-search/store/${storeName}/country/${countryCode}?${paramsToQuery({
    keyword,
    device,
  })}`)
}

export function getLiveSearchPlay({ storeName, countryCode, keyword, device, nextPageUrl }) {
  return makeRequest(`/keyword/live-search/store/${storeName}/country/${countryCode}/v3?${paramsToQuery({
    keyword,
    device,
    nextPageUrl,
  })}`)
}

export function getInAppsByKeyword({ countryCode, device, ids }) {
  return makeRequest(`/keyword/live-search/country/${countryCode}/device/${device}/in-apps?${paramsToQuery({ ids })}`)
}

export function getEditorialItems({ countryCode, device, ids }) {
  return makeRequest(`/keyword/live-search/country/${countryCode}/device/${device}/editorial-items?${paramsToQuery({ ids })}`)
}

export function getAppBundles({ countryCode, device, ids }) {
  return makeRequest(`/keyword/live-search/country/${countryCode}/device/${device}/app-bundles?${paramsToQuery({ ids })}`)
}
